import ax from 'axios';

const axios = ax.create({
  withCredentials: true
});

export function storeGet(route, store, once=false) {
  if(!once || (once && !store.fetching && !store.inited)) {
    store.fetching = true;

    axios.get(route).then((data) => {
      store.data = data.data.answer;
      store.inited = true;
      store.fetching = false;
    });
  }
}

export default axios;